"use client";

import React from "react";
import { MOVE_BRASIL_BANNER } from "@/app/config/moveBrasil";
import { BannerImage } from "@/app/components/MoveBrasil/BannerImage";
import styles from "@/styles/move-brasil.module.scss";

export const Banner: React.FC = () => {
	return (
		<section className={styles.bannerSection} aria-label="Banner Move Brasil">
			<picture className={styles.bannerPicture}>
				<source
					media="(max-width: 768px)"
					srcSet={MOVE_BRASIL_BANNER.mobile.src}
				/>
				<BannerImage
					src={MOVE_BRASIL_BANNER.desktop.src}
					alt={MOVE_BRASIL_BANNER.desktop.alt}
					className={styles.bannerImage}
					fallbackClassName={styles.bannerImageFallback}
				/>
			</picture>
		</section>
	);
};
